import { permissionActionName, permissionSubjectName, PermissionSuffix } from '@/service/api/core/enums/permission';
import { PermissionEnum } from '@vini-wine/core-enums';
export default [
    {
        path: '/administration/wine-searcher',
        name: 'administration-wine-searcher',
        component: () => import('@/views/wine-searcher/WineSearcher.vue'),
        meta: {
            resource: permissionSubjectName(PermissionEnum.CONTENT_VIEW, PermissionSuffix.USER),
            action: permissionActionName(PermissionEnum.CONTENT_VIEW),
            pageTitle: 'pageTitles.wineSearcher.wineSearcher',
            breadcrumb: [
                {
                    text: 'breadcrumbs.wineSearcher.wineSearcher.more',
                },
                {
                    text: 'breadcrumbs.wineSearcher.wineSearcher.wineSearcher',
                    active: true,
                },
            ],
        },
    },
];
